tinymce.addI18n("uz", {
    "#": "#",
    "Accessibility": "Maxsus qobiliyatlar",
    "Accordion": "",
    "Accordion body...": "",
    "Accordion summary...": "",
    "Action": "Harakat",
    "Activity": "Harakatlar",
    "Address": "Manzil",
    "Advanced": "Ilg'or",
    "Align": "Saflamoq",
    "Align center": "Markazga tekislash",
    "Align left": "Chapga tekislash",
    "Align right": "O'ngga tekislash",
    "Alignment": "Tekislash",
    "Alignment {0}": "",
    "All": "Hammasi",
    "Alternative description": "Muqobil tavsif",
    "Alternative source": "Muqobil manba",
    "Alternative source URL": "Muqobil manba URL manzili",
    "Anchor": "",
    "Anchor...": "",
    "Anchors": "Langarlar",
    "Animals and Nature": "Hayvonlar va Tabiat",
    "Arrows": "Strelkalar",
    "B": "B",
    "Background color": "Orqa fon rangi",
    "Background color {0}": "",
    "Black": "Qora",
    "Block": "Blok",
    "Block {0}": "",
    "Blockquote": "Matn blok parchasi",
    "Blocks": "Bloklar",
    "Blue": "Ko'k",
    "Blue component": "Ko'k komponent",
    "Body": "Tanasi",
    "Bold": "Qalin",
    "Border": "Chegara",
    "Border color": "Chegara rangi",
    "Border style": "Chegara stili",
    "Border width": "Chegara qalinligi",
    "Bottom": "Tagiga",
    "Browse files": "",
    "Browse for an image": "Rasmni yuklash",
    "Browse links": "",
    "Bullet list": "Nuqtali ro\u2018yxat",
    "Cancel": "Bekor qilish",
    "Caption": "Taglavha",
    "Cell": "Katak",
    "Cell padding": "Kataklar chegarasidan bo'sh joy",
    "Cell properties": "Katak hususiyatlari",
    "Cell spacing": "Kataklar orasi",
    "Cell styles": "Katak stillari",
    "Cell type": "Katak turi",
    "Center": "Markazga",
    "Characters": "Belgilar",
    "Characters (no spaces)": "Belgilar (bosh joylarsiz)",
    "Circle": "Doira",
    "Class": "Klass",
    "Clear formatting": "Formatlashni tozalash",
    "Close": "Yopish",
    "Code": "Kod",
    "Code sample...": "Kod namunasi...",
    "Code view": "Kod ko'rinishi",
    "Color Picker": "Rang tanlovchi",
    "Color swatch": "Rang namunasi",
    "Cols": "Ustunlar",
    "Column": "Ustun",
    "Column clipboard actions": "Ustunning almashish buferini harakatlari",
    "Column group": "Ustunlar guruhi",
    "Column header": "Ustun sarlavhasi",
    "Constrain proportions": "Nisbatlarni cheklash",
    "Copy": "Nusxa olish",
    "Copy column": "Ustunni nusxalash",
    "Copy row": "Satrdan nusxa ko'chirish",
    "Could not find the specified string.": "Belgilangan satr topilmadi.",
    "Could not load emojis": "Emojilar yuklanmadi",
    "Count": "Son",
    "Currency": "Valyuta",
    "Current window": "Joriy oyna",
    "Custom color": "O'zgacha rang",
    "Custom...": "O'zgacha...",
    "Cut": "Kesib olish",
    "Cut column": "Ustunni kesib olish",
    "Cut row": "Satrni kesib olish",
    "Dark Blue": "To'q ko'k",
    "Dark Gray": "To'q kulrang",
    "Dark Green": "To'q yashil",
    "Dark Orange": "To'q oranjiviy",
    "Dark Purple": "To'q siyohrang",
    "Dark Red": "To'q qizil",
    "Dark Turquoise": "",
    "Dark Yellow": "To'q sariq",
    "Dashed": "",
    "Date/time": "Kun/vaqt",
    "Decrease indent": "Satr boshini kamaytirish",
    "Default": "Standart",
    "Delete accordion": "",
    "Delete column": "Ustunni olib tashlash",
    "Delete row": "Satrni olib tashlash",
    "Delete table": "Jadvalni o'chirib tashlash",
    "Dimensions": "O'lchamlari",
    "Disc": "Disk",
    "Div": "Div",
    "Document": "Hujjat",
    "Dotted": "Nuqtali",
    "Double": "",
    "Drop an image here": "Bu erga rasmni olib o'ting",
    "Dropped file type is not supported": "Fayl turi qo'llab-quvvatlanmaydi",
    "Edit": "Tahrirlash",
    "Embed": "Ichiga olgan",
    "Emojis": "Emojilar",
    "Emojis...": "Emojilar...",
    "Error": "Xatolik",
    "Error: Form submit field collision.": "Xato: Formani yuborish maydonidagi konflikt.",
    "Error: No form element found.": "Xato: Form elementi topilmadi.",
    "Extended Latin": "Kengaytirilgan Lotin",
    "Failed to initialize plugin: {0}": "Plaginni ishga tushirib bo\u2018lmadi: {0}",
    "Failed to load plugin url: {0}": "Url plaginni yuklab bo\u2018lmadi: {0}",
    "Failed to load plugin: {0} from url {1}": "Plaginni yuklab bo\u2018lmadi: {0} {1} urldan",
    "Failed to upload image: {0}": "{0}ni yuklashda xatolik yuz berdi",
    "File": "Fayl",
    "Find": "Qidirish",
    "Find (if searchreplace plugin activated)": "Qidirish (qidirish plagini o'rnatilgan bo'lsa)",
    "Find and Replace": "Qidirish va O'zgartirish",
    "Find and replace...": "Qidirish va o'zgartirish...",
    "Find in selection": "Belgilangandan topish",
    "Find whole words only": "Faqat to'liq so'zni topish",
    "Flags": "Bayroqlar",
    "Focus to contextual toolbar": "Kontekstli vositalar paneliga e'tibor qaratish",
    "Focus to element path": "Elementlar manziliga e'tibor qaratish",
    "Focus to menubar": "Menubarga e'tibor qaratish",
    "Focus to toolbar": "Vositalar paneliga e'tibor qaratish",
    "Font": "Shrift",
    "Font size {0}": "",
    "Font sizes": "Shrift o'lchamlari",
    "Font {0}": "",
    "Fonts": "Shriftlar",
    "Food and Drink": "Ovqatlar va Ichimliklar",
    "Footer": "Tag qismi",
    "Format": "Shakllar",
    "Format {0}": "",
    "Formats": "Formatlar",
    "Fullscreen": "Butun ekran rejimi",
    "G": "G",
    "General": "Umumiy",
    "Gray": "Kulrang",
    "Green": "Yashil",
    "Green component": "Yashil komponent",
    "Groove": "",
    "Handy Shortcuts": "Foydalanadigan yorliqlar",
    "Header": "Sarlavha",
    "Header cell": "Sarlavha katagi",
    "Heading 1": "Sarlavha 1",
    "Heading 2": "Sarlavha 2",
    "Heading 3": "Sarlavha 3",
    "Heading 4": "Sarlavha 4",
    "Heading 5": "Sarlavha 5",
    "Heading 6": "Sarlavha 6",
    "Headings": "Sarlavhalar",
    "Height": "Balandligi",
    "Help": "Yordam",
    "Hex color code": "Hex rang kodi",
    "Hidden": "Yashirin",
    "Horizontal align": "Gorizontal tekislash",
    "Horizontal line": "Gorizontal chiziq",
    "Horizontal space": "Gorizontal o'lchov",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "ID harf bilan boshlanishi kerak, faqat harflar, raqamlar, tire, nuqta, ikki nuqta yoki pastki chiziqdan iborat bo'lishi kerak.",
    "Image is decorative": "Dekorativ rasm",
    "Image list": "Rasmlar ro'yhati",
    "Image title": "Rasm nomi",
    "Image...": "Rasm...",
    "ImageProxy HTTP error: Could not find Image Proxy": "ImageProxy HTTP xato: Image Proxy topilmadi",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "ImageProxy HTTP xato: Image Proxy URL noto'g'ri",
    "ImageProxy HTTP error: Rejected request": "ImageProxy HTTP xato: So'rov rad etildi",
    "ImageProxy HTTP error: Unknown ImageProxy error": "ImageProxy HTTP xato: Aniqlanmagan ImageProxy xato",
    "Increase indent": "Satr boshini oshirish",
    "Inline": "Bir qator ketma-ketlikda",
    "Insert": "Qo'shish",
    "Insert Template": "Shablon Joylashtirish",
    "Insert accordion": "",
    "Insert column after": "Ustunni ketidan qo'shish",
    "Insert column before": "Ustunni oldi tomoniga qo'shish",
    "Insert date/time": "Kun / vaqtni qo'shish",
    "Insert image": "Rasm qo'shish",
    "Insert link (if link plugin activated)": "Havolani qo'shish (havola plagini o'rnatilgan bo'lsa)",
    "Insert row after": "Ketidan satr qo'shish",
    "Insert row before": "Yuqorisiga satr qo'shish",
    "Insert table": "Jadvalni qo'shish",
    "Insert template...": "Shablon joylashtirish...",
    "Insert video": "Video qo'shish",
    "Insert/Edit code sample": "Kod namunasini qo'shish / tahrirlash",
    "Insert/edit image": "Rasmni qo'shish / tahrirlash",
    "Insert/edit link": "Havola qo'shish / tahrirlash",
    "Insert/edit media": "Media qo'shish / tahrirlash",
    "Insert/edit video": "Videoni qo'shish / tahrirlash",
    "Inset": "",
    "Invalid hex color code: {0}": "Hex rang kodi noto\u2018g\u2018ri: {0}",
    "Invalid input": "Noto'g'ri kiritish",
    "Italic": "Yotiq",
    "Justify": "Ikki tomondan tekislash",
    "Keyboard Navigation": "Klaviatura Navigatsiyasi",
    "Language": "Til",
    "Learn more...": "Batafsil ma'lumot...",
    "Left": "Chapga",
    "Left to right": "Chapdan o'ngga",
    "Light Blue": "Och ko'k",
    "Light Gray": "Och kulrang",
    "Light Green": "Och yashil",
    "Light Purple": "Och siyohrang",
    "Light Red": "Och qizil",
    "Light Yellow": "Och sariq",
    "Line height": "Chiziq balandligi",
    "Link list": "Havolalar ro'yhati",
    "Link...": "Havola...",
    "List Properties": "Ro'yxat Xususiyatlari",
    "List properties...": "Ro'yxat xususiyatlari...",
    "Loading emojis...": "Emojilar yuklanmoqda...",
    "Loading...": "Yuklanmoqda...",
    "Lower Alpha": "Kichik lotincha",
    "Lower Greek": "Pastki yunon",
    "Lower Roman": "Kichik kirilcha",
    "Match case": "O'xshashliklar",
    "Mathematical": "Matematik",
    "Media poster (Image URL)": "Media poster (Rasm URL)",
    "Media...": "Media...",
    "Medium Blue": "O\u02bbrtacha ko\u02bbk",
    "Medium Gray": "O'rtacha kulrang",
    "Medium Purple": "O\u02bbrtacha siyohrang",
    "Merge cells": "Kataklarni birlashtirish",
    "Middle": "Markaziga",
    "Midnight Blue": "Yarim tun ko'k",
    "More...": "Ko'proq...",
    "Name": "Nomi",
    "Navy Blue": "To'q ko'k rang",
    "New document": "Yangi hujjat",
    "New window": "Yangi oyna",
    "Next": "Keyingisi",
    "No": "Yo'q",
    "No alignment": "",
    "No color": "Rangsiz",
    "Nonbreaking space": "Buzilmas bo'sh joy",
    "None": "Hech bir",
    "Numbered list": "Raqamli ro\u2018yxat",
    "OR": "YOKI",
    "Objects": "Obyektlar",
    "Ok": "Ok",
    "Open help dialog": "Yordamni ochish",
    "Open link": "Havolani ochish",
    "Open link in...": "Havolani ...da ochish",
    "Open popup menu for split buttons": "Ajratish tugmalari uchun menyuni ochsh",
    "Orange": "Oranjiviy",
    "Outset": "",
    "Page break": "Yangi bet",
    "Paragraph": "Paragraf",
    "Paste": "Qo\u2018yish",
    "Paste as text": "Tekst qo'shish",
    "Paste column after": "Keyingi ustun qo'yish",
    "Paste column before": "Oldinga ustun qo'yish",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Joylashtirish oddiy matn rejimida amalga oshiriladi. Ushbu hususiyatni o'chirmaguningizcha, kontent oddiy matn sifatida joylashtiriladi.",
    "Paste or type a link": "Havolani joylashtirish yoki kiritish",
    "Paste row after": "Ketidan satrni joylashtirish",
    "Paste row before": "Yuqorisiga satrni joylashtirish",
    "Paste your embed code below:": "Kodni quyiga joylashtiring:",
    "People": "Odamlar",
    "Plugins": "Plaginlar",
    "Plugins installed ({0}):": "O'rnatilgan plaginlar ({0})",
    "Powered by {0}": "{0} bilan ishlaydi",
    "Pre": "Pre",
    "Preferences": "Afzalliklar",
    "Preformatted": "",
    "Premium plugins:": "Premium plaginlar:",
    "Press the Up and Down arrow keys to resize the editor.": "",
    "Press the arrow keys to resize the editor.": "",
    "Press {0} for help": "",
    "Preview": "Tahrirni avvaldan ko'rish",
    "Previous": "Oldingi",
    "Print": "Chop etish",
    "Print...": "Chop etish...",
    "Purple": "Siyohrang",
    "Quotations": "Iqtiboslar",
    "R": "R",
    "Range 0 to 255": "0 dan 255 gacha",
    "Red": "Qizil",
    "Red component": "Qizil komponent",
    "Redo": "Bekor qilish",
    "Remove": "Olib tashlash",
    "Remove color": "Rangni olib tashlash",
    "Remove link": "Havolani olib tashlash",
    "Replace": "Almashtirish",
    "Replace all": "Barchasini almashtirish",
    "Replace with": "bilan almashtirish",
    "Resize": "O'lchamini o'zgartirish",
    "Restore last draft": "Oxirgi ",
    "Reveal or hide additional toolbar items": "",
    "Rich Text Area": "Boy Matn Maydoni",
    "Rich Text Area. Press ALT-0 for help.": "Boy Matn Maydoni. Yordam olish uchun ALT-0 bosing.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Murakkab matn maydoni. Menyu uchun ALT-F9 tugmalarini bosing. Vositalar paneli uchun ALT-F10 tugmasini bosing. Yordamni chaqirish uchun ALT-0-ni bosing",
    "Ridge": "",
    "Right": "O'ngga",
    "Right to left": "O'ngdan chapga",
    "Row": "Satr",
    "Row clipboard actions": "Qatorning almashish buferini harakatlari",
    "Row group": "Satrlar guruhi",
    "Row header": "Qator sarlavhasi",
    "Row properties": "Satr hususiyatlari",
    "Row type": "Satr turi",
    "Rows": "Satrlar",
    "Save": "Saqlash",
    "Save (if save plugin activated)": "Saqlash (saqlash plagini o'rnatilgan bo'lsa)",
    "Scope": "Muhit",
    "Search": "Qidirish",
    "Select all": "Barchasini belgilash",
    "Select...": "Tanlash...",
    "Selection": "Tanlangan",
    "Shortcut": "Yorliq",
    "Show blocks": "Bloklarni ko'rsatish",
    "Show caption": "Sarlavhani ko'rish",
    "Show invisible characters": "Ko'rinmas belgilarni ko'rsatish",
    "Size": "O'lcham",
    "Solid": "",
    "Source": "Manba",
    "Source code": "Manba kodi",
    "Special Character": "Mahsus Belgi",
    "Special character...": "Mahsus belgi...",
    "Split cell": "Kataklarni bo'lish",
    "Square": "Kvadrat",
    "Start list at number": "Ro'yxatni raqamdan boshlash",
    "Strikethrough": "O'chirilgan yozuv",
    "Style": "Uslub",
    "Subscript": "Quyi yozuv",
    "Superscript": "Yuqori yozuv",
    "Switch to or from fullscreen mode": "To\u02bbliq ekran rejimiga o\u02bbtish",
    "Symbols": "Belgilar",
    "System Font": "Tizim shrifti",
    "Table": "Jadval",
    "Table caption": "Jadval sarlavhasi",
    "Table properties": "Jadval xususiyatlari",
    "Table styles": "Jadval stillari",
    "Template": "Andoza",
    "Templates": "Andozalar",
    "Text": "Matn",
    "Text color": "Matn rangi",
    "Text color {0}": "",
    "Text to display": "Ko'rsatiladigan matn",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": 'Siz kiritgan URL elektron pochta manziliga oxshayapti. "mailto:" prefiksi qo\'shilsinmi?',
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": 'Siz kiritgan URL tashqi havolaga oxshayapti. "http://" prefiksi qo\'shilsinmi?',
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "Siz kiritgan URL tashqi havolaga o'xshaydi. Kerakli https:// prefiksini qo'shmoqchimisiz?",
    "Title": "Nomi",
    "To open the popup, press Shift+Enter": "Menuni ochish uchun Shift+Enter bosing",
    "Toggle accordion": "",
    "Tools": "Vositalar",
    "Top": "Yuqoriga",
    "Travel and Places": "Sayohat va Joylar",
    "Turquoise": "",
    "Underline": "Tagi chizilgan",
    "Undo": "Orqaga qaytarish",
    "Upload": "Yuklash",
    "Uploading image": "Rasm yuklanmoqda",
    "Upper Alpha": "Katta lotincha",
    "Upper Roman": "Katta kirilcha",
    "Url": "URL",
    "User Defined": "Foydalanuvchi aniqlangan",
    "Valid": "Yaroqli",
    "Version": "Versiya",
    "Vertical align": "Vertikal tekislash",
    "Vertical space": "Vertikal o'lchov",
    "View": "Ko'rish",
    "Visual aids": "Ko\u2018rgazmali o\u2018quv qurollar",
    "Warn": "Ogohlantirish",
    "White": "Oq",
    "Width": "Kengligi",
    "Word count": "So'zlar soni",
    "Words": "So'zlar",
    "Words: {0}": "So'zlar soni: {0}",
    "Yellow": "Sariq",
    "Yes": "Ha",
    "You are using {0}": "Siz {0} ishlatmoqdasiz",
    "You have unsaved changes are you sure you want to navigate away?": "Sizda saqlanmagan o'zgartirishlar bor. Boshqa yerga chiqib ketish uchun ishonchingiz komilmi?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Sizning brauzeringiz buferga to\u2018g\u2018ridan-to\u2018g\u2018ri kirish qo\u2018llab-quvvatlamaydi. O\u2018rniga klaviaturaning Ctrl+X/C/V qisqartirishlarni foydalaning.",
    "alignment": "tekislash",
    "austral sign": "austral belgisi",
    "cedi sign": "cedi belgisi",
    "colon sign": "colon belgisi",
    "cruzeiro sign": "cruzeiro belgisi",
    "currency sign": "valyuta belgisi",
    "dollar sign": "dollar belgisi",
    "dong sign": "dong belgisi",
    "drachma sign": "drachma belgisi",
    "euro-currency sign": "yevro-valyuta belgisi",
    "example": "namuna",
    "formatting": "formatlash",
    "french franc sign": "fransiya franc belgisi",
    "german penny symbol": "nemis pennisi belgisi",
    "guarani sign": "guarani belgisi",
    "history": "tarix",
    "hryvnia sign": "hryvnia belgisi",
    "indentation": "",
    "indian rupee sign": "hind rupiysi belgisi",
    "kip sign": "kip belgisi",
    "lira sign": "lira belgisi",
    "livre tournois sign": "livre tournois belgisi",
    "manat sign": "manat belgisi",
    "mill sign": "mill belgisi",
    "naira sign": "naira belgisi",
    "new sheqel sign": "sheqel belgisi",
    "nordic mark sign": "shimoliy belgi belgisi",
    "peseta sign": "paseta belgisi",
    "peso sign": "peso belgisi",
    "ruble sign": "rubl belgisi",
    "rupee sign": "rupiy belgisi",
    "spesmilo sign": "spesmilo belgisi",
    "styles": "stillar",
    "tenge sign": "tenge belgisi",
    "tugrik sign": "tugrik belgisi",
    "turkish lira sign": "turkiya lirasi belgisi",
    "won sign": "von belgisi",
    "yen character": "yen belgisi",
    "yen/yuan character variant one": "yen/yuan belgisi, 1 variantda",
    "yuan character": "yuan belgisi",
    "yuan character, in hong kong and taiwan": "yuan belgisi, hong kong va tayvandagi",
    "{0} characters": "{0} belgi",
    "{0} columns, {1} rows": "",
    "{0} words": "{0} so`z"
});